import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../util';
import { useErrorHandling } from '../../hooks/useErrorHandling';
import generalRouteService from '../../services/general_route.service';
const MoveModal = _ref => {
  let {
    draggedElement,
    droppedElement,
    show,
    hideAndEmptyElements,
    allData,
    setAllData,
    route,
    isFile
  } = _ref;
  const {
    t
  } = useTranslation();
  const title = t('moving folders and files');
  const moveText = el => isFile(el) ? t('file') : t('folder');
  const body = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "text-center mt-2"
  }, `${moveText(draggedElement)}: ${draggedElement.name} >> ${moveText(droppedElement)}: ${droppedElement.name}`), /*#__PURE__*/React.createElement("h3", {
    className: "text-center mt-2"
  }, t('are_you_sure'), "?"));
  const updateData = useErrorHandling(useCallback(async () => {
    const isRouteFile = route === 'folder_files';
    const folderProperty = isRouteFile ? 'folder_id' : 'parent_folder_id';
    let payload = {
      [folderProperty]: droppedElement.id || null
    };
    if (droppedElement.virtual_folder && !isRouteFile) {
      payload = {
        ...payload,
        folderable_type: droppedElement.model_type,
        folderable_id: droppedElement.model_id,
        [folderProperty]: null
      };
    } else if (droppedElement.virtual_folder && isRouteFile) {
      payload = {
        ...payload,
        fileable_type: droppedElement.model_type,
        fileable_id: droppedElement.model_id,
        [folderProperty]: null
      };
    }
    const response = await generalRouteService.update(route, draggedElement.id, payload);
    const indexToRemove = allData.findIndex(currentData => currentData.id === response.id);
    allData.splice(indexToRemove, 1);
    setAllData([...allData]);
    hideAndEmptyElements();
  }, [body]));
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: title + ': ',
    show: show,
    renderBody: () => body,
    onHide: hideAndEmptyElements,
    onSubmit: () => updateData(),
    submitText: t('yes'),
    closeText: t('no'),
    submitIcon: "done"
  });
};
export default MoveModal;